import Swiper from "swiper";

var swiper = new Swiper(".mySwiper", {
    speed: 2000,
    autoplay: {
        delay: 1000,
    },
    effect: "fade",
    fadeEffect: {
        crossFade: true
    }
});

var floorswiper01, floorswiper02, floorswiper03, floorswiper04, floorswiper05, floorswiper06, floorswiper07, floorswiper08

floorswiper01 = new Swiper(".floorSwiper01", {
    spaceBetween: 50,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        type: "fraction",
    },

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});
if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0) {

} else {
    var about = new Swiper('.swiper-about', {
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: {
            enabled: true,
            sticky: true,
        },
        scrollbar: {
            dragSize: 47,
            draggable: true,
            el: '.swiper-scrollbar',
        },
        mousewheel: true,
    });
}